import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את האחיזה",
    opening: localizedGenderNode(
      [
      "היום אני קורא/ת לזה בשם.",
      "זו אהבה חד-צדדית שקשה לי לשחרר.",
      "אני כאן."
    ],
      [
      "היום אני קורא/ת לזה בשם.",
      "זו אהבה חד-צדדית שקשה לי לשחרר.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי האחיזה הזו חזקה במיוחד?",
      "מה אני אומר/ת לעצמי ברגעים האלה?",
      "איפה אני מרגיש/ה את זה בגוף?"
    ],
      [
      "מתי האחיזה הזו חזקה במיוחד?",
      "מה אני אומר/ת לעצמי ברגעים האלה?",
      "איפה אני מרגיש/ה את זה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "התחושה חזקה, אבל היא לא הגדרה שלי."
    ],
      [
      "התחושה חזקה, אבל היא לא הגדרה שלי."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני איתי בתוך זה\".",
      "נשימה אחת + \"אני איתי בתוך זה\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "עובדה מול דמיון",
    opening: localizedGenderNode(
      [
      "היום אני מבחין/ה בין מה שקורה לבין מה שאני מדמיין/ת.",
      "בלי להילחם.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מבחין/ה בין מה שקורה לבין מה שאני מדמיין/ת.",
      "בלי להילחם.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדות הפשוטות שיש לי?",
      "מה אני מוסיף/ה בדמיון?",
      "מה כואב לי כשאני רואה את העובדה?"
    ],
      [
      "מה העובדות הפשוטות שיש לי?",
      "מה אני מוסיף/ה בדמיון?",
      "מה כואב לי כשאני רואה את העובדה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עובדה לא מבטלת את הרגש."
    ],
      [
      "עובדה לא מבטלת את הרגש."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב עובדה אחת בלבד.",
      "לכתוב עובדה אחת בלבד."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה אני מחפש/ת שם",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל/ת על מה שאני מחפש/ת באהבה הזו.",
      "בלי להקטין.",
      "אני כאן."
    ],
      [
      "היום אני מסתכל/ת על מה שאני מחפש/ת באהבה הזו.",
      "בלי להקטין.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לחזה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לחזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו תחושה אני רוצה לקבל שם?",
      "מה אני מבקש/ת להרגיש על עצמי?",
      "מה אני מפחד/ת לאבד?"
    ],
      [
      "איזו תחושה אני רוצה לקבל שם?",
      "מה אני מבקש/ת להרגיש על עצמי?",
      "מה אני מפחד/ת לאבד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הצורך שלי אמיתי, גם אם הכיוון כואב."
    ],
      [
      "הצורך שלי אמיתי, גם אם הכיוון כואב."
    ]
    ),
    action: localizedGenderNode(
      "משפט קצר של צורך.",
      "משפט קצר של צורך."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "הלופ הפנימי",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הלופ של הגעגוע.",
      "רק מזהה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מזהה את הלופ של הגעגוע.",
      "רק מזהה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הלופ הזה מתחיל בדרך כלל?",
      "מה מחזיק אותו בחיים?",
      "איפה אפשר לעצור רגע קטן?"
    ],
      [
      "איך הלופ הזה מתחיל בדרך כלל?",
      "מה מחזיק אותו בחיים?",
      "איפה אפשר לעצור רגע קטן?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לופ יכול לכלול עצירה קטנה."
    ],
      [
      "לופ יכול לכלול עצירה קטנה."
    ]
    ),
    action: localizedGenderNode(
      "עצירה של 10 שניות פעם אחת.",
      "עצירה של 10 שניות פעם אחת."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "גבול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איפה אני חוצה גבול עם עצמי.",
      "בלי אשמה.",
      "אני כאן."
    ],
      [
      "היום אני בודק/ת איפה אני חוצה גבול עם עצמי.",
      "בלי אשמה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ],
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני עושה שמעמיק את הכאב?",
      "איזה גבול קטן אפשר לי לשים היום?",
      "ממה אני מפחד/ת אם אשים אותו?"
    ],
      [
      "מה אני עושה שמעמיק את הכאב?",
      "איזה גבול קטן אפשר לי לשים היום?",
      "ממה אני מפחד/ת אם אשים אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן הוא הגנה עדינה."
    ],
      [
      "גבול קטן הוא הגנה עדינה."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול פנימי אחד.",
      "משפט גבול פנימי אחד."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "טריגרים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מפעיל אותי סביב האהבה הזו.",
      "רק מזהה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מזהה מה מפעיל אותי סביב האהבה הזו.",
      "רק מזהה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הכי מפעיל אותי? (מקום/שיר/זמן)",
      "איזה רגש עולה מיד?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ],
      [
      "מה הכי מפעיל אותי? (מקום/שיר/זמן)",
      "איזה רגש עולה מיד?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מזהה טריגר אני לא לבד בו."
    ],
      [
      "כשאני מזהה טריגר אני לא לבד בו."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה כשזה עולה.",
      "יד על החזה כשזה עולה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "החלק שמקווה",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת מקום לחלק שמקווה.",
      "בלי לבטל אותו.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת מקום לחלק שמקווה.",
      "בלי לבטל אותו.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הכתפיים.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הכתפיים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה יפה בתקווה שלי?",
      "מה קשה בתקווה הזו?",
      "מה אני רוצה להגן עליו?"
    ],
      [
      "מה יפה בתקווה שלי?",
      "מה קשה בתקווה הזו?",
      "מה אני רוצה להגן עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "התקווה שלי ראויה לרוך."
    ],
      [
      "התקווה שלי ראויה לרוך."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לתקווה.",
      "משפט רך אחד לתקווה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "החלק שמתאבל",
    opening: localizedGenderNode(
      [
      "היום אני מאפשר/ת לעצב להיות כאן.",
      "לא כדי לשקוע בו.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מאפשר/ת לעצב להיות כאן.",
      "לא כדי לשקוע בו.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לעיניים ולנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לעיניים ולנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "על מה אני מתאבל/ת כאן?",
      "מה רציתי לתת?",
      "מה רציתי לקבל?"
    ],
      [
      "על מה אני מתאבל/ת כאן?",
      "מה רציתי לתת?",
      "מה רציתי לקבל?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "העצב הוא אהבה שאין לה מקום."
    ],
      [
      "העצב הוא אהבה שאין לה מקום."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם העצב.",
      "נשימה אחת עם העצב."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "איך זה נוגע בערך שלי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה נוגע בערך שלי.",
      "לא לשפוט.",
      "אני כאן."
    ],
      [
      "היום אני בודק/ת איך זה נוגע בערך שלי.",
      "לא לשפוט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני אומר/ת לעצמי עליי במצב הזה?",
      "מה הייתי אומר/ת לחבר/ה כאן?",
      "במה אני רוצה להאמין עליי?"
    ],
      [
      "מה אני אומר/ת לעצמי עליי במצב הזה?",
      "מה הייתי אומר/ת לחבר/ה כאן?",
      "במה אני רוצה להאמין עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הערך שלי לא תלוי בתשובה מבחוץ."
    ],
      [
      "הערך שלי לא תלוי בתשובה מבחוץ."
    ]
    ),
    action: localizedGenderNode(
      "משפט ערך אחד לעצמי.",
      "משפט ערך אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הבטן מתרככת מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הבטן מתרככת מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת היא עוגן קטן."
    ],
      [
      "בקשה אחת היא עוגן קטן."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן בלב היום.",
      "לא מהפכה.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת שינוי קטן בלב היום.",
      "לא מהפכה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה שינוי קטן שאני מוכן/ה לנסות היום?",
      "מתי הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ],
      [
      "מה שינוי קטן שאני מוכן/ה לנסות היום?",
      "מתי הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי קטן הוא תנועה עדינה."
    ],
      [
      "שינוי קטן הוא תנועה עדינה."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד לנסות.",
      "לבחור רגע אחד לנסות."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להישאר איתי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו אני נשאר/ת איתי.",
      "במקום לרדוף.",
      "אני כאן."
    ],
      [
      "היום אני שם/ה לב לרגע שבו אני נשאר/ת איתי.",
      "במקום לרדוף.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני נוטה לרדוף בדמיון?",
      "איך נראה רגע של להישאר איתי?",
      "מה אני מרגיש/ה אחריו?"
    ],
      [
      "מתי אני נוטה לרדוף בדמיון?",
      "איך נראה רגע של להישאר איתי?",
      "מה אני מרגיש/ה אחריו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי זה צעד של בחירה."
    ],
      [
      "להישאר איתי זה צעד של בחירה."
    ]
    ),
    action: localizedGenderNode(
      "לומר בלב \"אני איתי\" פעם אחת.",
      "לומר בלב \"אני איתי\" פעם אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "כיוון חדש קטן",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת מקום לכיוון קטן חדש.",
      "לא רחוק, רק אפשרי.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת מקום לכיוון קטן חדש.",
      "לא רחוק, רק אפשרי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חשוב לי להרגיש יותר בחיים?",
      "איזה ערך קטן אני רוצה לחיות היום?",
      "מה סימן קטן שזה קורה?"
    ],
      [
      "מה חשוב לי להרגיש יותר בחיים?",
      "איזה ערך קטן אני רוצה לחיות היום?",
      "מה סימן קטן שזה קורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כיוון קטן יכול להספיק להיום."
    ],
      [
      "כיוון קטן יכול להספיק להיום."
    ]
    ),
    action: localizedGenderNode(
      "משפט ערך אחד קצר.",
      "משפט ערך אחד קצר."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ],
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על האהבה הזו?",
      "מה הסימן המוקדם שאני חוזר/ת ללופ?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ],
      [
      "מה למדתי על האהבה הזו?",
      "מה הסימן המוקדם שאני חוזר/ת ללופ?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לאהוב ולהישאר איתי."
    ],
      [
      "אני יכול/ה לאהוב ולהישאר איתי."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני תגובה.",
      "נשימה אחת לפני תגובה."
    ),
  },
].map(buildNormalizedDay);

export const gettingStuckOnAnImpossibleOneSidedLoveBlueprintHe = buildNormalizedPilotBlueprint({
  id: "getting_stuck_on_an_impossible_one_sided_love_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "getting_stuck_on_an_impossible_one_sided_love",
  category: "love_and_relationships",
  journeyName: {
    he: "אהבה בלתי אפשרית / חד-צדדית",
    en: "Getting stuck in an impossible one-sided love",
    es: "Quedarme atrapado/a en un amor imposible y unilateral",
  },
  days,
});

export default gettingStuckOnAnImpossibleOneSidedLoveBlueprintHe;
